import DashboardView from '../../../components/DashboardView/DashboardView';

// Dashboard dos clientes (group_admin / hotel_admin). Reutiliza a vista
// partilhada; o scoping por grupo vem de `accessibleGroups` (backend). O card
// "Pedidos sem resposta" navega para a rota de cliente.
export default function MyDashboard() {
  return <DashboardView unansweredTo="/my-unanswered-messages" sessionDetailsTo="/my-sessions" />;
}
